import PropTypes from 'prop-types';
import React from 'react';
import Image, { getVariantUrls } from '@fenderdigital/react-ui-kit/image';
import StyledMarkDown from '../../../components/StyledMarkDown/StyledMarkDown';
import ItunesButton from '../../../components/ItunesButton';
import Media, { formatMinutes } from '../../../components/Media';
import { getCurriculumImage } from '../../../utils/curriculum-utils';
import { isSongRiff } from './lesson-utils';
import * as S from './Lesson-styled';

const getImage = (image, type) => {
  if (!image || !isSongRiff(type)) return null;
  const images = getVariantUrls(image, 'square', 'smallThumb');
  return (
    <div className="mb4 mt3 mt0-l w4-l w4 mr4">
      <Image images={images} ratio={1 / 1} />
    </div>
  );
};

const getDescription = lesson => {
  const description = lesson['description-long'] || '';
  return <StyledMarkDown description={description} />;
};

const getAppleLink = appleLink => {
  if (!appleLink) return null;
  return (
    <S.LessonInfoListItem>
      <p>Buy</p>
      <p>
        <ItunesButton appleLink={appleLink} />
      </p>
    </S.LessonInfoListItem>
  );
};

const getInfoGrid = (type, name, timeToFinish, appleLink) => {
  return (
    <S.LessonInfoList>
      <S.LessonInfoListItem>
        <p>Lesson Type</p>
        <p data-id="info-icon-lesson-type">
          <span>{type}</span>
        </p>
      </S.LessonInfoListItem>
      <S.LessonInfoListItem>
        <p>Instructor</p>
        <p data-id="info-icon-instructor">{name}</p>
      </S.LessonInfoListItem>
      <S.LessonInfoListItem>
        <p>Time to Finish</p>
        <p data-id="info-icon-time-to-finish">{timeToFinish}</p>
      </S.LessonInfoListItem>
      {isSongRiff(type) ? (
        <S.LessonInfoListItem>{getAppleLink(appleLink)}</S.LessonInfoListItem>
      ) : null}
    </S.LessonInfoList>
  );
};

const LessonInfo = ({ appleLink, lesson }) => {
  const { type } = lesson || {};
  const activityVideo = lesson['activity-lesson-video'] || {};
  const { duration, instructor } = activityVideo;
  const { name } = instructor || {};
  const timeToFinish = formatMinutes(duration);
  return (
    <S.LessonInfoContainer>
      <S.LessonInfoHeader>
        {appleLink ? getImage(getCurriculumImage(lesson), type) : null}
        {getInfoGrid(type, name, timeToFinish, appleLink)}
      </S.LessonInfoHeader>
      <S.LessonInfoText>{getDescription(lesson)}</S.LessonInfoText>
    </S.LessonInfoContainer>
  );
};

LessonInfo.propTypes = {
  appleLink: PropTypes.string,
  lesson: PropTypes.shape({}),
};

LessonInfo.defaultProps = {
  appleLink: null,
  lesson: '',
};

export default LessonInfo;
